import React from 'react';
import ReactDOM from 'react-dom';
import { browserHistory, Router, Route, IndexRoute, Link } from 'react-router';

class TimelineInnerNavi extends React.Component{
	

	render(){

		return (<div className="timeline-chapter-navi">
							<Link className="timeline-track-navi" to={_assets.root + "/chapter1"}>1<span className="tool-tip-link">chapter 1</span></Link>
							<Link className="timeline-track-navi" to={_assets.root + "/chapter2"}>2<span className="tool-tip-link">chapter 2</span></Link>
							<Link className="timeline-track-navi" to={_assets.root + "/chapter3"}>3<span className="tool-tip-link">chapter 3</span></Link>
						</div>);
	}
}

export default TimelineInnerNavi;


// WEBPACK FOOTER //
// ./src/scripts/timelineInnerNavi.js